import { Alert, Button, FormControl, FormHelperText, Paper, TextField, useTheme } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { Link, RouteChildrenProps } from "react-router-dom";
import logo from '../../images/logo_safedesk.png';
import logoBackgrounf from '../../images/logo_commbox_transparent_full.png';
import UserApi from "../../service/UserApi";
import { PermissionError } from "../../service/Errors";

interface ForgotPasswordPageProps extends RouteChildrenProps {
    //successLoginAction: typeof successLoginAction;
    //logoutAction: typeof logoutAction;
    //loadingAction: typeof loadingAction;
}

function ForgotPasswordPage(props: ForgotPasswordPageProps) {

    //const { history, location } = props;

    const [login, setLogin] = useState<string>('');
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [emailSent, setEmailSent] = useState<boolean>(false);

    const { enqueueSnackbar } = useSnackbar();
    const theme = useTheme();

    const serviceAuthUser = new UserApi();

    function onLoginChangeHandler(ev: React.ChangeEvent<HTMLInputElement>) {
        setLogin(ev.target.value);
        if (errorMessage !== '') {
            setErrorMessage('');
        }
    }

    async function onSubmitHandler(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        if (login.trim().length < 3) {
            setErrorMessage('Login inválido.');
            return;
        }

        try {
            await serviceAuthUser.forgotPassword({ login: login.trim() })
            setEmailSent(true);
        } catch(e){
            var errorMsg = 'Erro ao enviar e-mail de redefinição de senha.';
            if (e instanceof PermissionError) {
                errorMsg = e.message;
            }
            enqueueSnackbar(errorMsg, { variant: 'error', autoHideDuration: 10000 });
        }
    }

    const margin = theme.spacing(3);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', backgroundSize: 'cover', alignContent: 'center', justifyContent: 'center', alignItems: 'center', placeContent: 'center', flexGrow: 1, backgroundImage: `url(${logoBackgrounf})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center center' }}>
            <Paper style={{ width: 400, padding: margin, display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', paddingBottom: margin }}>
                    <img src={logo} alt="Logo" style={{ height: 60 }} />
                </div>
                {!emailSent && <form onSubmit={onSubmitHandler} style={{ display: 'flex', flexDirection: 'column' }}>
                    <Alert severity="info">Você receberá um e-mail para trocar sua senha.</Alert>
                    <TextField
                        variant="standard"
                        label='Login ou e-mail'
                        onChange={onLoginChangeHandler}
                        value={login}
                        type='text'
                        style={{ paddingBottom: margin }}
                        autoComplete='off'
                        required
                        autoFocus />
                    <FormControl variant="standard">
                        <Button type="submit" variant='contained' color='primary'>Enviar</Button>
                    </FormControl>
                </form>}
                {emailSent && <Alert severity="success">E-mail de redefinição de senha enviado.</Alert>}
                {(errorMessage && !emailSent) && <FormHelperText error={true}>{errorMessage}</FormHelperText>}
                <Link to='/login' style={{ textDecoration: 'none', fontSize: '0.9em', marginTop: 10 }} >Voltar para login</Link>
            </Paper>
        </div>
    );
}

export default ForgotPasswordPage;